import PlainDivider from './PlainDivider';

export default PlainDivider;
